import { useEffect } from 'react';
import { normalizeVersion } from '@genoma/version-banner';

declare const __APP_VERSION_RAW__: string;

export function useVersionEnforcer() {
  useEffect(() => {
    if (import.meta.env.DEV) return;

    const checkVersion = async () => {
      if (typeof window !== 'undefined' && window.electronAPI) return;

      try {
        const res = await fetch('/version.json?nocache=' + Date.now());
        if (!res.ok) return;

        const contentType = res.headers.get('content-type') || '';
        if (!contentType.includes('application/json')) return;

        const data = await res.json();
        const serverVersion = normalizeVersion(data.version);
        const localVersion = typeof __APP_VERSION_RAW__ !== 'undefined' ? normalizeVersion(__APP_VERSION_RAW__) : null;

        if (serverVersion && localVersion && serverVersion !== localVersion) {
          console.warn(`[VersionEnforcer] Mismatch! Local: ${localVersion}, Server: ${serverVersion}. Purging caches and reloading.`);

          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const reg of registrations) {
              if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
              await reg.unregister();
            }
          }

          if ('caches' in window) {
            const keys = await caches.keys();
            for (const key of keys) {
              await caches.delete(key);
            }
          }

          window.location.reload();
        }
      } catch (err) {
        console.error('[VersionEnforcer] Check error:', err);
      }
    };

    checkVersion();
    const onVisibility = () => {
      if (document.visibilityState === 'visible') checkVersion();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
}